module.exports = __webpack_public_path__ + "static/media/Image1.f6804385.svg";